import { defineTranslations } from "../typeHelpers/defineTranslations"
import type { TranslationRecord } from "../types/translationTypes"
import type { en } from "./en"

export const dk = defineTranslations<TranslationRecord<typeof en>>()({
  "actions": "Handlinger",
  "add": "Tilføj",
  "age": "Alder",
  "age.month": "måned",
  "age.year": "år",
  "apply": "Udfør",
  "birthday": "Fødselsdag",
  "born": "Født",
  "cancel": "Annuller",
  "close": "Luk",
  "collapsedText.hide": "Skjule",
  "collapsedText.show": "Vis mere",
  "confirm": "Bekræft",
  "confirmClose.accept": "Kassér",
  "confirmClose.body": "Hvis du kasserer dine inputs, vil dine ændringer ikke blive gemt.",
  "confirmClose.title": "Kassér ændringer?",
  "copy": "Kopiér",
  "count.items": "{count} emner",
  "create": "Opret",
  "danish": "Dansk",
  "datePicker.label": "Dato",
  "dateRangePicker.label": "Datointerval",
  "delete": "Slet",
  "details": "Detaljer",
  "download": "Download",
  "dutch": "Hollandsk",
  "edit": "Rediger",
  "empty": "Tom",
  "emptyState.items": "data",
  "emptyState.noItems": "Ingen {itemName}",
  "english": "Engelsk",
  "entries.add": "Tilføj {entry}",
  "entries.add.another": "Tilføj {entry}",
  "error.400.message": "Ugyldig anmodning",
  "error.401.message": "Ikke autoriseret",
  "error.403.message": "Utilstrækkelig adgang",
  "error.404.message": "Ikke fundet",
  "error.408.message": "Timeout",
  "error.fallback.message": "Der opstod en fejl",
  "false": "Nej",
  "filter": "Filter",
  "filterFormButtons.reset": "Nulstil",
  "filterFormButtons.search": "Søg",
  "finish": "Færdig",
  "form.showOnlyChanges": "Vis kun ændringer",
  "genericUnavailableAction": "Handling ikke tilgængelig grundet de aktuelle data/rettigheder.",
  "input.clear": "Ryd",
  "input.nothingFound": "Ingen resultater fundet",
  "input.startToAdd": "Begynd at skrive for at tilføje…",
  "input.startTyping": "Begynd at skrive for at søge…",
  "inputWrapper.bigger": "Den nye værdi er større end den eksisterende værdi.",
  "inputWrapper.defaultValueTooltip": "Klik for at gå tilbage til standardværdien",
  "inputWrapper.different": "Den nye værdi er forskellig fra den eksisterende værdi.",
  "inputWrapper.existingValueTooltip": "Klik for at gå tilbage til den eksisterende værdi",
  "inputWrapper.smaller": "Den nye værdi er mindre end den eksisterende værdi.",
  "markdownViewer.media.unsupportedFormat": "Ikke-understøttet medieformat. Brug venligst MP4 til videoaktiver og PNG eller JPG/JPEG-kodning til billeder.",
  "markdownViewer.video.unsupported": "Din browser understøtter ikke dette videoformat.",
  "months": "{months} måneder",
  "next": "Næste",
  "no": "Nej",
  "none": "Ingen",
  "notFound": "Ikke fundet",
  "open": "Åbn",
  "option.noDataAvailable": "Ingen data tilgængelig",
  "previous": "Forrige",
  "retry": "Forsøg igen",
  "save": "Gem",
  "search": "Søg",
  "select.label": "Vælg",
  "select.noResults": "Ingen resultater fundet",
  "select.pleaseTypeToSearch": "Begynd at skrive for at søge",
  "signout": "Log ud",
  "table.filter.dateRangeTitle": "Datointerval",
  "table.filter.maxTitle": "Maks.",
  "table.filter.minTitle": "Min.",
  "table.filter.toggleAll": "Vælg alle",
  "total": "Total",
  "true": "Ja",
  "undo": "Fortryd",
  "upload": "Upload",
  "validation.between": "Værdien skal være mellem {min} og {max}",
  "validation.email": "Indtast en gyldig e-mailadresse",
  "validation.invalidDate": "Indtast en gyldig dato",
  "validation.length": "Værdien skal være {length} tegn langt",
  "validation.max": "Værdien skal være mindre eller lig med {max}",
  "validation.min": "Værdien skal være større eller lig med {min}",
  "validation.required": "Værdien er påkrævet",
  "year": "{years} år",
  "years": "{years} år",
  "yes": "Ja",
})
